<template>
  <div>
    <div class="news_title" style="margin-bottom:50px;">
      投诉与咨询服务
      <span class="iconfont">&#xe70b;</span>信息跟踪与查询
    </div>
    <div style="padding:0 200px;margin-top:100px;">
      <el-input placeholder="请输入您的查询单号" v-model="input1">
        <!-- <template slot="prepend">请输入您的查询单号</template> -->
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
    </div>
    <div style="padding:0 200px;margin-top:50px;" v-if="yc">
      <h2 style="padding-left:20px;">{{result_states}}</h2>
      <div style="padding-left:20px;font-size:14px;">
        <p>转办单位：<span>{{checkresult.transfer_unit}}</span></p>
        <p>处理结果：<span>{{checkresult.result}}</span></p>
        <p>回复人：<span>{{checkresult.reply_person}}</span></p>
        <p>登记人：<span>{{checkresult.registrant}}</span></p>
        <p>转办人：<span>{{checkresult.transfer_person}}</span></p>
        <p>答复人：<span>{{checkresult.reponse_person}}</span></p>
        <!-- <p>转办单位：<span>{{}}</span>登记人：<span>{{}}</span></p> -->
      </div>
    </div>
  </div>
</template>
<script>
import { ipconfig } from "@/assets/js/ipconfig.js";
import Axios from "axios";
export default {
  name: "msgTrackingAndQuery",
  data() {
    return {
      input1: "",
      state: null,
      yc: false,
      checkresult:null
    };
  },
  methods: {
    search() {
      if (!this.input1) {
        alert("请输入您要查询的单号！");
      }
      let param = new URLSearchParams();
      param.append("con_order_id", this.input1);
      Axios.post(
        `http://${ipconfig}/app/isweb/complain/getComplainInfo?innerMS`,
        param
      ).then(res => {
        // debugger;
        this.state = res.data.data.complainInfo[0].state;
        this.checkresult = res.data.data.complainInfo[0]
        this.yc = true;
      });
    }
  },
  computed: {
    result_states() {
      if (this.state == "0") {
        return "处理结果：未处理";
      } else {
        return "处理结果：处理完毕";
      }
    }
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/tszxsevers/msgTrackingAndQuery.vue


// WEBPACK FOOTER //
// src/pages/tszxsevers/msgTrackingAndQuery.vue